module.exports = __webpack_public_path__ + "img/instantkegs-symbol.cd35415c.png";